import React, { Component } from 'react';

export default class Op_Info_Display_Row extends Component {
	constructor(props) {
		super(props);

		this.state = {
		}
	}

	render() {
		let key = Object.keys(this.props.data)[0];
		let val = this.props.data[key]; // val is the value of operation time in sec
		let hour = Math.floor(val / 3600);
		let min = Math.floor((val % 3600) / 60);
		let hour_display = '';
		let min_display = '';

		if (hour < 10) {
			hour_display = '0' + hour;
		} else {
			hour_display = hour;
		}

		if (min < 10) {
			min_display = '0' + min;
		} else {
			min_display = min;
		}

		return (
			<div style={this.props.row_style}>
				<div style={this.props.table_cell_style}>
					<span >{this.props.point_info.name}</span>
				</div>
				<div style={this.props.table_cell_style}>
					<span >{hour_display + ':' + min_display}</span>
				</div>
			</div>
		)
	}
}